import MD5 from 'md5.js';

export const defaultAction = '/kit/mss/upload';

const splitFileName = fileName => {
    const arr = fileName.split('.');
    let [name, ext] = ['', ''];
    if (arr.length === 1 || (!arr[0] && arr.length === 2) || !arr[arr.length - 1]) { // abcd, .abcd, abcd.a..
        name = fileName;
        ext = '';
    } else {
        ext = arr.pop();
        name = arr.join('.');
    }
    return [name, ext];
};

export const getFileUrl = (res, file, fileList) => {
    // {域名}/v1/mss_{tenantId}/{containername}/{objectname}
    const { $fileName, $bucketName } = file.raw;
    const isProd = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging';
    const domain = isProd ? 'https://s3plus.meituan.net' : 'https://msstest-corp.sankuai.com';
    const tenantId = isProd ? '915cfe67c99b4651b81ca210670f9302' : '156341e12eb248878e532dd820706c40';
    return `${domain}/v1/mss_${tenantId}/${$bucketName}/${$fileName}`;
};

export const getFileUrlCommon = res => {
    if (
        Object.prototype.toString.call(res) !== '[object Object]' ||
        Object.prototype.toString.call(res.data) !== '[object Object]'
    ) {
        throw new Error('接口返回数据结构错误');
    }
    return res.data.url;
};

export const getFileName = file => {
    const fileName = file.name;
    let [name, ext] = splitFileName(fileName);
    return `${new MD5().update(name).digest('hex')}.${Date.now()}${ext ? '.' : ''}${ext}`;
};

export const getNameByUrl = url => {
    let arr = url.split('/');
    return arr[arr.length - 1] || url;
};

const imgExts = [
    'jpg',
    'png',
    'jpeg',
    'bmp',
    'gif'
    // 'svg'
];

export const isImg = url => {
    const ext = (url || '').split('.').slice(-1)[0];
    return imgExts.includes(ext.toLowerCase());
};
